// extracted by css-extract-rspack-plugin
var _1 = "bEwg06M7GIE5HUjq";
var _2 = "Omn03miMt1kIHQqj";
var _3 = "A7xPjZXC2wM07rbx";
var _4 = "wxMKioGlsiMYY3Zi";
var _5 = "HlElV3HO9TkIZVPs";
var _6 = "A7xPjZXC2wM07rbx";
var _7 = "wxMKioGlsiMYY3Zi";
var _8 = "HlElV3HO9TkIZVPs";
export { _1 as "identifier", _2 as "matchevent", _3 as "matchevent--goal", _4 as "matchevent--in", _5 as "matchevent--out", _6 as "matcheventGoal", _7 as "matcheventIn", _8 as "matcheventOut" }
